// sort by added date by default
// use sort_volume to sort by volume

export default [
  {
    "name": "NonKYC",
    "link": "https://nonkyc.io/market/XEL_USDT",
    "logo_img": "https://docs.xelis.io/exchanges/nonkyc_logo.webp",
    "market_img": "https://docs.xelis.io/exchanges/nonkyc.webp",
    "sort_volume": 6
  },
  {
    "name": "CoinEx",
    "link": "https://www.coinex.com/en/exchange/xel-usdt",
    "logo_img": "https://docs.xelis.io/exchanges/coinex_logo.webp",
    "market_img": "https://docs.xelis.io/exchanges/coinex.webp",
    "sort_volume": 3
  },
  {
    "name": "MEXC",
    "link": "https://www.mexc.com/exchange/XEL_USDT",
    "logo_img": "https://docs.xelis.io/exchanges/mexc_logo.webp",
    "market_img": "https://docs.xelis.io/exchanges/mexc.webp",
    "sort_volume": 0
  },
  {
    "name": "SafeTrade",
    "link": "https://safetrade.com/exchange/XEL-USDT",
    "logo_img": "https://docs.xelis.io/exchanges/safetrade_logo.webp",
    "market_img": "https://docs.xelis.io/exchanges/safetrade.webp",
    "sort_volume": 7
  },
  {
    "name": "Trocador",
    "link": "https://trocador.app/en/?ticker_to=xel",
    "logo_img": "https://docs.xelis.io/exchanges/trocador_logo.webp",
    "market_img": "https://docs.xelis.io/exchanges/trocador.webp",
    "sort_volume": 2
  },
]